import http from './http'
import tools from '@/service/tools'
import Qs from 'qs'

const BIU_SERVICE_HOST = process.env.VUE_APP_BIU_SERVICE_HOST

export class Api {

  public static async isLogin () {

    const is_login = tools.getCookie('is_login')
    if (is_login) {
      const token = localStorage.getItem('token')
      const userid = localStorage.getItem('userid')
      const res: any = await http.get(BIU_SERVICE_HOST + '/verify-token',
        {
          userid: userid,
          ticket: token
        })
      if (res.data.status === 'valid') {
        return true
      }
    }

    return false
  }

  public static async autoLogin (page_url: string) {

    const url_parts = page_url.split('?')
    const part1 = url_parts[0]
    let url = part1 + '?'
    let login_ticket
    let userid
    if (url_parts.length > 1) {
      const query = Qs.parse(url_parts[1])
      login_ticket = query.__login_ticket__
      userid = query.__userid__

      for (const key in query) {
        if (key === '__login_ticket__' || key === '__userid__') {
          continue
        }
        const v = query[key] as string
        console.info(key)
        console.info(v)
        url = url + key + '=' + encodeURIComponent(v) + '&'
      }
    }

    if (login_ticket && userid) {
      const response: any = await Api.exchangeToken(userid as string, login_ticket as string)
      if (response.data.token) {
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('userid', userid as string)
        tools.setCookie('is_login', '1')
        location.href = url
        return
      }
    }

    url = location.protocol + '//' + location.host + url
    url = encodeURIComponent(url)

    const LMS_MANAGER_HOST = process.env.VUE_APP_LMS_MANAGER_HOST as string
    const spa_login_url = LMS_MANAGER_HOST + '/spa-login?url=' + url

    console.info('3----------' + spa_login_url)

    location.href = spa_login_url
  }

  public static exchangeToken (userid: string, login_ticket: string) {
    const res = http.get(BIU_SERVICE_HOST + '/exchange-token',
      {
        userid: userid,
        ticket: login_ticket
      })
    return res
  }

  public static getMenu () {
    const res = http.get(BIU_SERVICE_HOST + '/menu')
    return res
  }

  public static getMyInfo () {
    const res = http.get(BIU_SERVICE_HOST + '/my-info')
    return res
  }

  public static getNextStudent () {
    const res = http.get(BIU_SERVICE_HOST + '/next-student')
    return res
  }

  public static getWaitConfirmData () {
    const res = http.get(BIU_SERVICE_HOST + '/refresh-wait-confirm-order-data')
    return res
  }

  public static getStudentOrder (student_ids: string) {
    const res = http.get(BIU_SERVICE_HOST + '/student-order', { student_ids: student_ids })
    return res
  }

  public static updateStudentOrder (putData: any) {
    const res = http.put(BIU_SERVICE_HOST + '/update-student-order', putData, null)
    return res
  }

  public static keyUserConfirm (student_ids: string) {
    const data = {
      student_ids: student_ids
    }
    const res = http.put(BIU_SERVICE_HOST + '/key-user-confirm', data, null)
    return res
  }

  public static keyUserWaitConfirm (student_ids: string) {
    const data = {
      student_ids: student_ids
    }
    const res = http.put(BIU_SERVICE_HOST + '/key-user-wait-confirm', data, null)
    return res
  }

  public static loadGzhList () {
    const res = http.get(BIU_SERVICE_HOST + '/biu-service/gzh-list')
    return res
  }

  public static getGzhInfo (app_id: string) {
    const res = http.get(BIU_SERVICE_HOST + '/biu-service/gzh-info', { app_id: app_id })
    return res
  }

  public static pullGzhMenu (app_id: any) {
    const res = http.get(BIU_SERVICE_HOST + '/biu-service/pull-gzh-menu', { app_id: app_id })
    return res
  }

  public static createGzhMenu (app_id: string) {
    const data = {
      app_id
    }
    const res = http.postParams(BIU_SERVICE_HOST + '/biu-service/create-gzh-menu', data)
    return res
  }

  public static gzhMenuList (app_id: any) {
    const res = http.get(BIU_SERVICE_HOST + '/biu-service/gzh-menu-list', { app_id: app_id })
    return res
  }

  public static copyGzhMenu (app_id: string, gzh_menu_id: number) {
    const data = {
      app_id,
      gzh_menu_id
    }
    const res = http.postParams(BIU_SERVICE_HOST + '/biu-service/copy-gzh-menu', data)
    return res
  }

  public static getGzhMenuInfo (app_id: string, gzh_menu_id: number) {
    const res = http.get(BIU_SERVICE_HOST + '/biu-service/gzh-menu-info', { app_id: app_id, gzh_menu_id: gzh_menu_id })
    return res
  }

  public static getGzhTagList (app_id: any) {
    const res = http.get(BIU_SERVICE_HOST + '/biu-service/gzh-tag-list', { app_id: app_id })
    return res
  }

  public static saveGzhMenu (app_id: string, gzh_menu_id: number, name: string, content: string) {
    const data = {
      app_id: app_id,
      gzh_menu_id: gzh_menu_id,
      name: name,
      content: content,
    }
    const res = http.put(BIU_SERVICE_HOST + '/biu-service/save-gzh-menu', data)
    return res
  }

  public static deleteGzhMenu (app_id: string, gzh_menu_id: string) {
    const data = {
      app_id: app_id,
      gzh_menu_id: gzh_menu_id
    }
    const res = http.delParams(BIU_SERVICE_HOST + '/biu-service/delete-gzh-menu', data)
    return res
  }

  public static publishGzhMenu (app_id: string, gzh_menu_id: number) {
    const data = {
      app_id,
      gzh_menu_id
    }
    const res = http.putParams(BIU_SERVICE_HOST + '/biu-service/publish-gzh-menu', data)
    return res
  }
}
